import React from 'react';
import PropTypes from 'prop-types';
import './index.less'
const CustomTickBox = ({ className, onClick, label, isActive }) => {
    return (
        <span
            onClick={onClick}
            className={`checkbox-container ${className}`}>
            <span className={`checkmark ${isActive ? 'checkmark_active' : ''}`} />
            {label !== "" && label}
        </span>
    );
}

CustomTickBox.propTypes = {
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired
}
export default CustomTickBox;


// WEBPACK FOOTER //
// ./src/components/common/CustomTickBox/index.jsx